export default (new window.PexRTC());
